import { ChangeEvent, FC } from 'react';
import { Box, MenuItem, TextField, Typography } from '@material-ui/core';
import { Field } from 'formik';
import { useStyles } from '../../styles';

interface Props {
    value: string;
    disabled?: boolean;
    handleChange: (e: ChangeEvent) => void;
}
const TypeField: FC<Props> = ({ value, handleChange, disabled }) => {
    const classes = useStyles();

    return (
        <Box className={classes.row}>
            <Typography className={classes.label}>Event type</Typography>
            <Field
                component={TextField}
                autoComplete="off"
                select
                disabled={disabled}
                variant="outlined"
                value={value}
                onChange={handleChange}
                InputProps={{ name: 'type', className: classes.field }}
            >
                <MenuItem key="Interactive" value="Interactive">
                    Interactive
                </MenuItem>
                <MenuItem key="Broadcast" value="Broadcast">
                    Broadcast
                </MenuItem>
            </Field>
        </Box>
    );
};

export default TypeField;
